// JsFromRoutes CacheKey dc9d53f40adf6723fb9b3b9ef68ceb21
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  terminate: /* #__PURE__ */ definePathHelper('post', '/employers/employees/terminate'),
  duplicates: /* #__PURE__ */ definePathHelper('get', '/employers/employees/duplicates'),
  index: /* #__PURE__ */ definePathHelper('get', '/employers/employees'),
  show: /* #__PURE__ */ definePathHelper('get', '/employers/employees/:id'),
}
